
<template>

	<mymodal ref="modal" title="Группировка" ok="Применить" :reset="reset" :check="check" :submit="submit">

		<b-form-checkbox v-model="all">Группировать объекты, разгруппированные присвоением оценочной группы / подгруппы из справочника</b-form-checkbox>

	</mymodal>

</template>

<script>

import mymodal from "./modal"

export default
{
	components :
	{
		mymodal,
	},

	data()
	{
		return {

			all : false,

		}
	},

	methods :
	{
		check()
		{
			return true
		},

		reset()
		{
			this.all = false
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			this.$emit("group", { all : this.all })
		}
	}
}

</script>

